import { UiTabModel } from "../../models";

import {
    mock$AssetModel,
    mockUiColumnModel,
    mockUiColumnModelContent,
    mockUiImageModel,
    mockUiImageModelContent,
    mockUiMarkdownModel,
    mockUiMarkdownModelContent
} from ".";

export function mockUiTabModel({
    id = "tab-1234",
    type = "uiTab",
    locale = "en",
    content = mockUiTabModelContent()
}: Partial<UiTabModel> = {}): UiTabModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiTabModelContent = UiTabModel["content"];

export function mockUiTabModelContent({
    entryTitle = "Example Tab Component",
    buttonText = "Example",
    columns = [
        mockUiColumnModel({
            id: "1",
            content: mockUiColumnModelContent({
                properties: {
                    xs: { align: "left", order: 2 },
                    md: { span: 5, order: 1 }
                },
                blocks: [
                    mockUiMarkdownModel({
                        content: mockUiMarkdownModelContent({
                            content:
                                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                        })
                    })
                ]
            })
        }),
        mockUiColumnModel({
            id: "2",
            content: mockUiColumnModelContent({
                properties: {
                    xs: { align: "left", order: 1 },
                    md: { span: 6, offset: 1, order: 2 }
                },
                blocks: [
                    mockUiImageModel({
                        content: mockUiImageModelContent({
                            image: mock$AssetModel({
                                url: "/ui-callout/calendar-view.png"
                            })
                        })
                    })
                ]
            })
        })
    ],
    ...optionals
}: Partial<UiTabModelContent> = {}): UiTabModelContent {
    return {
        entryTitle,
        buttonText,
        columns,
        ...optionals
    };
}
